import React, { useCallback, useEffect, useState } from 'react';
import { Button, Text } from '@rsos/base-components';
import { useFlag } from '@rsos/flags';
import { StyledDebugMenu } from './DebugMenu.styles';
import panels from './panels';

interface DebugMenuProps {
  onError?: (error: string) => void;
}

const DEBUG_MENU_HOT_KEY = 'ALT+SHIFT+D';

const DebugMenu: React.FC<DebugMenuProps> = ({ onError }) => {
  const isDebugPanelEnabled = useFlag('debug-panel');
  const [isDebugPanelVisible, setIsDebugPanelVisible] = useState(false);
  const [activePanel, setActivePanel] = useState<string | null>(null);
  const onClose = () => {
    setActivePanel(null);
  };

  const toggleVisible = useCallback(
    (e: KeyboardEvent) => {
      // NOTE: if you update the key update DEBUG_MENU_HOT_KEY
      if (e.altKey && e.shiftKey && e.code === 'KeyD') {
        setIsDebugPanelVisible(v => !v);
        e.preventDefault();
        e.stopPropagation();
      }
    },
    [setIsDebugPanelVisible],
  );

  useEffect(() => {
    if (isDebugPanelEnabled) {
      window.addEventListener('keydown', toggleVisible);
    }
    return () => {
      window.removeEventListener('keydown', toggleVisible);
    };
  }, [toggleVisible, isDebugPanelEnabled]);

  if (!isDebugPanelEnabled || !isDebugPanelVisible) {
    return null;
  }

  return (
    <StyledDebugMenu>
      <Text size="small" color="primaryText">
        DEBUG MENU
        <br />({DEBUG_MENU_HOT_KEY} to hide)
      </Text>
      {panels.map(panel => (
        <div key={panel.id}>
          <Button
            onClick={() => setActivePanel(panel.id)}
            btnType="tertiary"
            noMargin
          >
            {panel.label}
          </Button>
          {panel.id === activePanel &&
            panel.component({
              onError,
              onClose,
            })}
        </div>
      ))}
    </StyledDebugMenu>
  );
};

export default DebugMenu;
